export default "__VITE_ASSET__BU1jxVqD__"